import { Grid, Theme, Typography, useMediaQuery, useTheme } from "@mui/material";
import React, { FC } from "react";

import { Link } from "react-router-dom";

// import { createStyles, makeStyles } from "@mui/material/styles";

// const useStyles = makeStyles((theme: Theme) =>
// 	createStyles({
// 		title: {
// 			fontWeight: "bold",
// 			color: "#000000de",
// 		},
// 		subTitle: {
// 			fontWeight: "bold",
// 			color: "#00000099",
// 			paddingTop: theme.spacing(1),
// 			paddingLeft: theme.spacing(0.5),
// 			paddingBottom: theme.spacing(4),
// 		},
// 		subTitleLink: {
// 			textDecoration: "none",
// 			cursor: "pointer",
// 			color: theme.palette.primary.main,
// 		},
// 	})
// );

export interface IAccountLayoutFormProps {
	/**
	 * Title of account form layout
	 */
	title?: string;
	/**
	 * Subtitle of account form layout
	 */
	subtitle?: string;
	/**
	 * Include link in subtitle of account form layout
	 */
	subtitleLinkText?: string;
	/**
	 * The user will be redirected on which page after click on the link
	 */
	subtitleLinkNavigateTo?: string;
	/**
	 * Form to be displayed
	 */
	form: React.ReactNode;
}

export const AccountFormLayout: FC<IAccountLayoutFormProps> = ({
	title,
	subtitle,
	subtitleLinkText,
	subtitleLinkNavigateTo,
	form,
}) => {
	// const classes = useStyles();
	const testId = "form-layout";
	// RESPONSIVE
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
	const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
	const isMediumScreen01 = useMediaQuery(theme.breakpoints.between(900, 1200));
	const mobileTabOrSmallLaptopScreen = isMobile || isSmallScreen || isMediumScreen01;


	return (
		<Grid container data-testid={testId}>
			<Grid size={{ xs: 0, sm: 1, md: 2, lg: 2, xl: 2 }}></Grid>
			<Grid size={{ xs: 12, sm: 10, md: 8, lg: 8, xl: 8 }}>
				<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} data-testid={testId + "-title"}>
					<Typography
						variant={isMobile ? "h5" : "h4"}
						sx={{ fontWeight: "bold", color: "#000000de" }}
						style={{ fontWeight: "bold" }}
					>
						{title}
					</Typography>
				</Grid>
				<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} data-testid={testId + "-subtitle"}>
					<Typography
						variant="subtitle2"
						sx={{
							fontWeight: "bold",
							color: "#00000099",
							pt: 1,
							pl: 0.5,
							pb: 4,
						}}
						style={{ fontWeight: isMobile ? "normal" : "bold" }}
					>
						{subtitle}&nbsp;
						<Link
							to={subtitleLinkNavigateTo ?? ""}
							style={{
								textDecoration: "none",
								color: "#1976d2", // MUI primary.main default
								cursor: "pointer",
							}}
							data-testid={testId + "-subtitleLink"}
						>
							{subtitleLinkText}
						</Link>
					</Typography>
				</Grid>
				<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} data-testid={testId + "-form"}>
					{form}
				</Grid>
			</Grid>
			<Grid size={{ xs: 0, sm: 1, md: 2, lg: 2, xl: 2 }}></Grid>
		</Grid>
	);
};
